import { render, staticRenderFns } from "./LabelTypeSelection.vue?vue&type=template&id=a7955c3a&scoped=true"
import script from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LabelTypeSelection.vue?vue&type=style&index=0&id=a7955c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7955c3a",
  null
  
)

export default component.exports